import { FC } from 'react'
import { Icon } from '@/client/components'
import { useRouterPush, useAuthUser, useGetCartItems } from '@/client/hooks'
import { ROUTER_PATH } from '@/client/utils'
import * as S from './styles'

const Login: FC<{ greet_user: string }> = ({ greet_user }) => {
  const { isAuthenticated, user } = useAuthUser()
  const { defaultLocale } = useRouterPush()
  const { data } = useGetCartItems()

  return (
    <S.LoginAnchor
      $isAuthenticated={isAuthenticated}
      href={isAuthenticated ? ROUTER_PATH.MY_ACCOUNT[defaultLocale] : ROUTER_PATH.LOGIN[defaultLocale]}
    >
      {isAuthenticated ? (
        <S.HeaderIndicator>
          <S.IndicatorWrapper>
            {data && data?.cart_items && data?.cart_items.length > 0 && (
              <S.Indicator>
                <div className='ini' />
              </S.Indicator>
            )}
          </S.IndicatorWrapper>
          <S.InformationWrapper>
            <Icon name='person' size='s5' />
            {isAuthenticated && (
              <S.Greet>
                {greet_user}, {user?.name}
              </S.Greet>
            )}
          </S.InformationWrapper>
        </S.HeaderIndicator>
      ) : (
        <Icon name='person' size='s5' />
      )}
    </S.LoginAnchor>
  )
}

export default Login
